import { render } from "./MyTable.vue?vue&type=template&id=4044ea8c&scoped=true"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"

import "./MyTable.vue?vue&type=style&index=0&id=4044ea8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4044ea8c"]])

export default __exports__